<template>
<select class="form-control" v-model="localValue">
  <option v-for="option in options" :value="option.value">{{ option.label }}</option>
</select>
</template>
<script>
export default {
  props: {
    value: {required: true},
    options: {type: Array, required: true}
  },
  data () {
    return {
      localValue: this.value
    }
  },
  watch: {
    localValue (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectInput.vue?397d3a5d